import { Link } from 'react-router-dom';
import { Wordmark } from '@/components/Wordmark';

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-bone px-6 text-center">
      <Wordmark className="text-2xl" />
      <div className="space-y-2">
        <p className="font-mono text-xs uppercase tracking-widest text-ink-muted">404</p>
        <h1 className="text-3xl font-medium tracking-tight text-ink">No joint to hold here.</h1>
        <p className="max-w-sm text-sm text-ink-muted">
          The page you're looking for doesn't exist, or never did.
        </p>
      </div>
      <Link
        to="/"
        className="rounded-full bg-ink px-6 py-2.5 text-sm font-medium text-bone transition-colors hover:bg-ink-soft"
      >
        Go home
      </Link>
    </div>
  );
}
